import MessagingIntegrationsPage from '../common/MessagingIntegrationsPage';

export default function AgencyMessagingIntegrations() {
  return <MessagingIntegrationsPage isAdminView={false} />;
}
